import React, { useState, useRef, useEffect } from "react";
import { endPoints } from "../../constant/Environment";
import {
  addData,
  deleteData,
  getAllData,
  getAllFilterData,
} from "../../Utility/API";
import { Modal, Form, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { Actions } from "../../redux/Actions/Actions";
import Toaster from "../../components/Toast";
import Loader from "../../components/Loader";
import { ErrorToast, SuccesToast } from "../../components/Toast/message";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Dialog from "@mui/material/Dialog";
import FormControlLabel from "@mui/material/FormControlLabel";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import FormHelperText from "@mui/material/FormHelperText";
import FormControl from "@mui/material/FormControl";
import Switch from "@mui/material/Switch";

const CreateLoyalty = (props) => {

  const { onClose, editData, open, ...other } = props;
  const [isLoading, setIsLoading] = useState(false);
  const [viptitle, setVipTitle] = useState("");
  const [creative, setCreative] = useState("");
  const [depositrequired, setDepositRequired] = useState("");
  const [viptype, setVipType] = useState("");
  const [weeklyboost, setWeeklyBoost] = useState("");
  const [giftdelivery, setGiftDelivery] = useState("");
  const [cashredeem, setCashRedeem] = useState("");
  const [exclusivegames, setExclusiveGames] = useState("");
  const [level, setLevel] = useState("");
  const [birthdaybonus, setBirthdayBonus] = useState("");
  const [withdrawlimit, setWithdrawLimit] = useState("");
  const [freespin, setFreeSpin] = useState("");
  const [luxuryreward, setLuxuryReward] = useState("");
  const [rakebackpercentage, setRakebackPercentage] = useState("");

  const handleCancel = () => {
    onClose();
  };

  useEffect(()=>{
    if(open){
       setVipTitle(editData?.packagename||"");
       setWeeklyBoost(editData?.weekly_boost||"");
       setGiftDelivery(editData?.gift_delivery||"");
       setCashRedeem(editData?.cash_redemption||"");
       setExclusiveGames(editData?.exclusive_games||"");
       setVipType(editData?.vip_club_access||"");
       setLevel(editData?.level||"");
       setDepositRequired(editData?.deposit_required||"");
       setBirthdayBonus(editData?.birthday_bonus||"");
       setWithdrawLimit(editData?.withdrawl_limit||"");
       setLuxuryReward(editData?.luxury_rewards||"");
       setFreeSpin(editData?.free_spins||"");
       setRakebackPercentage(editData?.rakeback_percentage ?? "");
       setCreative(editData?.levelimage);
    }
  },[editData,open])


  const handleOk = () => {
    if (
      viptitle &&
      weeklyboost &&
      giftdelivery &&
      cashredeem &&
      viptype &&
      creative &&
      depositrequired &&
      level &&
      luxuryreward &&
      birthdaybonus &&
      freespin &&
      withdrawlimit &&
      rakebackpercentage !== "" &&
      rakebackpercentage !== null &&
      rakebackpercentage !== undefined
    )
    {
    let url =  editData?.id
      ? `${endPoints.api.UPDATE_VIP_PACKAGE}`
      :`${endPoints.api.CREATE_VIP_PACKAGE}`;
    let payload = {
      packagename: viptitle,
      gift_delivery:giftdelivery,
      cash_redemption:cashredeem,
      exclusive_games:exclusivegames,
      weekly_boost: weeklyboost,
      vip_club_access:viptype,
      levelimage: creative,
      level:level,
      deposit_required:depositrequired,
      birthday_bonus:birthdaybonus,
      withdrawl_limit:withdrawlimit,
      luxury_rewards:luxuryreward,
      free_spins:freespin,
      rakeback_percentage:rakebackpercentage,
      isActive: 0,
      startdate:"",
      enddate:"",
    };
    if (editData?.id) {
      payload.id = editData.id;
    }
    setIsLoading(true);
    addData(url, payload)
      .then((response) => {
        setIsLoading(false);
        if (response.data.status === "success") {
          SuccesToast(response?.data?.message);
          onClose();
        }
      })
      .catch((error) => {
        setIsLoading(false);
        console.error(error);
        ErrorToast(error);
      });
    }else{
      debugger
         ErrorToast("all fields are required");   
    }
  };

    const handleFileChange = (event) => {
      const file = event.target.files[0];
      if (file) {
        const imageUrl = URL.createObjectURL(file);
        setCreative(file);
        UploadImage(file);
      }
    };
    const UploadImage = (files) => {
      var formdata = new FormData();
      formdata.append("file", files);
      var requestOptions = {
        method: "POST",
        body: formdata,
        redirect: "follow",
      };
      setIsLoading(true);
      let imgUrl = `${endPoints.apiBaseUrl}${endPoints.api.UPLOAD_BANNER}`;
      fetch(imgUrl, requestOptions)
        .then((response) => response.json())
        .then((result) => {
          setCreative(result.data);
          setIsLoading(false);
          SuccesToast(result.message);
        })
        .catch((error) => {
          ErrorToast(error);  
          console.log("error", error)
        });
    };

  return (
    <Dialog
      sx={{ "& .MuiDialog-paper": { width: "80%", maxHeight: 435 } }}
      maxWidth="md"
      open={open}
      {...other}
    >
      <DialogTitle>Loyalty Level Info </DialogTitle>

      <DialogContent dividers>
        <Toaster></Toaster>
        {isLoading && <Loader spinner={true} visible={isLoading} />}

        <div className="row">
        <div className="col-md-6">
        <FormControl style={{ width: "100%", marginTop: "20px" }}>
          <TextField
            id="filled-required"
            variant="outlined"
            label="Package Title"
            value={viptitle}
            onChange={(event) => {
              setVipTitle(event.target.value);
            }}
          />
        </FormControl>
        </div>

        <div className="col-md-6">
        <FormControl style={{ width: "100%", marginTop: "20px" }}>
          <TextField
            id="filled-required"
            variant="outlined"
            label="Deposit Required ($)"
            type="number"
            value={depositrequired}
            onChange={(event) => {
              setDepositRequired(event.target.value);
            }}
          />
        </FormControl>
        </div>
        </div>

        <div className="row">
        <div className="col-md-6">
        <FormControl style={{ width: "100%", marginTop: "20px" }}>
          <TextField
            id="filled-required"
            variant="outlined"
            label="Weekly bonus boost"
            value={weeklyboost}
            onChange={(event) => {
              setWeeklyBoost(event.target.value);
            }}
          />
        </FormControl>
        </div>
        </div>

        <div className="row">
        <div className="col-md-6">
           <Form.Group
            className="mb-3 mt-3"
          >
            <Form.Label>Gift card delivery</Form.Label>
            <Form.Select value={giftdelivery} onChange={(event) => {
              setGiftDelivery(event.target.value);
            }}>
              <option value=''>Select option</option>
              <option value={'No'}>No</option>
              <option value={'120 Hours'}>120 Hours</option>
              <option value={'96 Hours'}>96 Hours</option>
              <option value={'72 Hours'}>72 Hours</option>
              <option value={'48 Hours'}>48 Hours</option>
              <option value={'24 Hours'}>24 Hours</option>
              <option value={'Instant'}>Instant</option>
            </Form.Select>
          </Form.Group>
          </div>

          <div className="col-md-6">
          <Form.Group
            className="mb-3 mt-3"
          >
            <Form.Label>Cash Redemption</Form.Label>
            <Form.Select value={cashredeem} onChange={(event) => {
              setCashRedeem(event.target.value);
            }}>
              <option value=''>Select option</option>
              <option value={'No'}>No</option>
              <option value={'120 Hours'}>120 Hours</option>
              <option value={'96 Hours'}>96 Hours</option>
              <option value={'72 Hours'}>72 Hours</option>
              <option value={'48 Hours'}>48 Hours</option>
              <option value={'24 Hours'}>24 Hours</option>
              <option value={'Instant'}>Instant</option>
            </Form.Select>
          </Form.Group>
          </div>
          </div>

          <div className="row">
        <div className="col-md-6">
           <Form.Group
            className="mb-3 mt-3"
          >
            <Form.Label>Birthday Bonus</Form.Label>
            <Form.Select value={birthdaybonus} onChange={(event) => {
              setBirthdayBonus(event.target.value);
            }}>
              <option value=''>Select option</option>
              <option value={'No'}>No</option>
              <option value={'1'}>1</option>
              <option value={'1.5'}>1.5</option>
              <option value={'2'}>2</option>
              <option value={'2.5'}>2.5</option>
              <option value={'3'}>3</option>
              <option value={'3.5'}>3.5</option>
              <option value={'5'}>5</option>
            </Form.Select>
          </Form.Group>
          </div>

          <div className="col-md-6">
          {/* <Form.Group
            className="mb-3 mt-3"
          >
            <Form.Label>Withdrawl Limit</Form.Label>
            <Form.Select value={withdrawlimit} onChange={(event) => {
              setWithdrawLimit(event.target.value);
            }}>
              <option value=''>Select option</option>
              <option value={'25'}>25</option>
              <option value={'50'}>50</option>
              <option value={'100'}>100</option>
              <option value={'200'}>200</option>
              <option value={'300'}>300</option>
            </Form.Select>
          </Form.Group> */}
          <FormControl style={{ width: "100%", marginTop: "20px" }}>
            <TextField
              id="withdraw-limit"
              variant="outlined"
              label="Enter Withdrawal Limit"
              type="number"
              value={withdrawlimit}
              onChange={(event) => setWithdrawLimit(event.target.value)}
              placeholder="Enter limit"
            />
          </FormControl>

          </div>
          </div>

          <div className="row">
        <div className="col-md-6">
           <Form.Group
            className="mb-3 mt-3"
          >
            <Form.Label>Luxury Reward</Form.Label>
            <Form.Select value={luxuryreward} onChange={(event) => {
              setLuxuryReward(event.target.value);
            }}>
              <option value=''>Select option</option>
              <option value={'1'}>Yes</option>
              <option value={'2'}>No</option>
            </Form.Select>
          </Form.Group>
          </div>

          <div className="col-md-6">
          <Form.Group
            className="mb-3 mt-3"
          >
            <Form.Label>Free Spin</Form.Label>
            <Form.Select value={freespin} onChange={(event) => {
              setFreeSpin(event.target.value);
            }}>
              <option value=''>Select option</option>
              <option value={'No'}>No</option>
              <option value={'10'}>10</option>
              <option value={'20'}>20</option>
            </Form.Select>
          </Form.Group>
          </div>
          </div>

          <div className="row">
          <div className="col-md-6">
          <Form.Group
            className="mb-3 mt-3"
          >
            <Form.Label>Vip Club Access</Form.Label>
            <Form.Select value={viptype} onChange={(event) => {
              setVipType(event.target.value);
            }}>
              <option value=''>Select option</option>
              <option value={'1'}>Yes</option>
              <option value={'2'}>No</option>
            </Form.Select>
          </Form.Group>
          </div>

        <div className="col-md-6">

        <Form.Group
            className="mb-3 mt-3"
          >
            <Form.Label>Exclusive games</Form.Label>
            <Form.Select value={exclusivegames} onChange={(event) => {
              setExclusiveGames(event.target.value);
            }}>
              <option value=''>Select option</option>
              <option value={'1'}>Yes</option>
              <option value={'2'}>No</option>
            </Form.Select>
          </Form.Group>
        </div>
        </div>

        <div className="row">
        <div className="col-md-6">
          <Form.Group className="mb-3" controlId="game">
            <Form.Label>Upload Creative </Form.Label>
            <Form.Control
              type="file"
              placeholder="Upload Creative"
              onChange={handleFileChange}
            />
          </Form.Group>
        </div>

        <div className="col-md-6">
        <FormControl style={{ width: "100%", marginTop: "20px" }}>
          <TextField
            id="filled-required"
            variant="outlined"
            label="Level"
            value={level}
            InputLabelProps={{
              shrink: true,
            }}
            onChange={(event) => {
              setLevel(event.target.value);
            }}
          />
        </FormControl>

        {/* <FormControlLabel
                  control={
                    <Switch
                      name="active"
                      value={isActive}
                      onClick={() => {
                        setIsActive(!isActive);
                      }}
                      defaultChecked={isActive}
                    />
                  }
                  labelPlacement="start"
                  label="Active"
                /> */}
                </div>
                </div>

        <div className="row">
        <div className="col-md-6">
        <FormControl style={{ width: "100%", marginTop: "20px" }}>
          <TextField
            id="rakeback-percentage"
            variant="outlined"
            label="Rakeback Percentage"
            type="number"
            value={rakebackpercentage}
            onChange={(event) => {
              setRakebackPercentage(event.target.value);
            }}
          />
        </FormControl>
        </div>
        </div>

      </DialogContent>
      <DialogActions>
        <Button autoFocus onClick={handleCancel}>
          Cancel
        </Button>
        <Button onClick={handleOk}>Ok</Button>
      </DialogActions>
    </Dialog>
  );
};

export default CreateLoyalty;
